<!-- content -->
<img src="assets/images/404.png" class="w-[400px] max-w-full" />
<h1>{{ this.error?.title }}</h1>
<p>{{ this.error?.message }}</p>
<!-- button -->
<button
  [routerLink]="'/sign-in'"
  (click)="analyticsService.logEvent('error_sign-in_click')"
>
  Entrar novamente
</button>
